import { FC } from "react";
import {
  Box,
  FormControlLabel,
  Switch,
  Typography,
  Paper,
} from "@mui/material";
import { Email, NotificationsActive } from "@mui/icons-material";

interface ChannelControlsProps {
  emailEnabled: boolean;
  pushEnabled: boolean;
  onEmailChange: (value: boolean) => void;
  onPushChange: (value: boolean) => void;
  disabled?: boolean;
}

const ChannelControls: FC<ChannelControlsProps> = ({
  emailEnabled,
  pushEnabled,
  onEmailChange,
  onPushChange,
  disabled = false,
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Email */}
      <Paper variant="outlined" className="p-3">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="subtitle1">
              {<Email />} Notificações por Email
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {emailEnabled ? "Habilitadas" : "Desabilitadas"}
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={emailEnabled}
                onChange={e => onEmailChange(e.target.checked)}
                disabled={disabled}
                color="secondary"
              />
            }
            label=""
          />
        </Box>
      </Paper>

      {/* Push */}
      <Paper variant="outlined" className="p-3">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="subtitle1">
              {<NotificationsActive />} Notificações Push
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {pushEnabled ? "Habilitadas" : "Desabilitadas"}
            </Typography>
          </Box>
          <FormControlLabel
            control={
              <Switch
                checked={pushEnabled}
                onChange={e => onPushChange(e.target.checked)}
                disabled={disabled}
                color="secondary"
              />
            }
            label=""
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default ChannelControls;
